const CLOSE_BAR_PREFIX = 'mplayer-close-bar';

const CLOSE_ICON = 'close-icon';
const CONTAINER = 'container';
const TITLE = 'title';
const TITLE_TOOLTIP = 'title-tooltip';

export const getCloseIconId = (playerId: string): string => `${CLOSE_BAR_PREFIX}-${CLOSE_ICON}-${playerId}`;

export const getTitleId = (playerId: string): string => `${CLOSE_BAR_PREFIX}-${TITLE}-${playerId}`;

export const getTitleTooltipId = (playerId: string): string => `${CLOSE_BAR_PREFIX}-${TITLE_TOOLTIP}-${playerId}`;

export const getContainerId = (playerId: string): string => `${CLOSE_BAR_PREFIX}-${CONTAINER}-${playerId}`;
